// What ocs-site's /api returns (crates/ocs-site, docs/13 "API"). Times are RFC 3339 strings.
import type { PortableWorkflow } from "../workflows/portable";

export interface PostSummary {
  slug: string;
  title: string;
  subtitle: string | null;
  excerpt: string;
  author: string;
  cover: string | null;
  cover_alt: string | null;
  tags: string[];
  series: string | null;
  part: number | null;
  reading_minutes: number;
  published_at: string;
}

export interface Post extends PostSummary {
  body_md: string;
  cover_credit: string | null;
}

export interface PostPage {
  post: Post;
  next: PostSummary | null;
  previous: PostSummary | null;
}

export interface WorkflowSummary {
  slug: string;
  name: string;
  summary: string;
  category: string;
  tags: string[];
  icon: string | null;
  publisher: string;
  featured: boolean;
  latest_version: number;
  version_count: number;
  step_count: number;
  approval_count: number;
  updated_at: string;
}

export interface Category {
  name: string;
  count: number;
}

export interface WorkflowList {
  workflows: WorkflowSummary[];
  categories: Category[];
}

export interface VersionSummary {
  version: number;
  changelog: string;
  published_at: string;
  step_count: number;
}

export interface VersionDetail {
  version: number;
  changelog: string;
  published_at: string;
  demo_path: string[];
  document: PortableWorkflow;
}

export interface WorkflowPage {
  workflow: WorkflowSummary & { description: string };
  versions: VersionSummary[];
  latest: VersionDetail;
}

export const INTERESTS = ["broker", "workflows", "cloud", "contribute", "publish"] as const;
export type Interest = (typeof INTERESTS)[number];

export interface SignatureInput {
  name: string;
  email: string;
  organisation?: string;
  list_publicly: boolean;
  wants_updates: boolean;
  interests: Interest[];
  /** The honeypot: people leave it empty. */
  website: string;
}

export interface SignatureResult {
  signatures: number;
  already: boolean;
}
